module.exports = __webpack_public_path__ + "img/icon38.423ce794.png";